import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



import { ChartjsBarComponent } from './chartjs/chartjs-bar.component';
import { ChartjsLineComponent } from './chartjs/chartjs-line.component';
import { ChartjsPieComponent } from './chartjs/chartjs-pie.component';
import { ChartjsMultipleXaxisComponent } from './chartjs/chartjs-multiple-xaxis.component';
import { ChartjsBarHorizontalComponent } from './chartjs/chartjs-bar-horizontal.component';
import { ChartjsRadarComponent } from './chartjs/chartjs-radar.component';
import {ChartModule} from "angular2-chartjs";
import {ChartjsComponent} from "./chartjs/chartjs.component";



const components = [
  ChartjsBarComponent,
  ChartjsLineComponent,
  ChartjsPieComponent,
  ChartjsMultipleXaxisComponent,
  ChartjsBarHorizontalComponent,
  ChartjsRadarComponent,
  ChartjsComponent
];


@NgModule({
  imports: [
    CommonModule,
    ChartModule

  ],
  exports: [
    ChartjsBarComponent,
    ChartjsLineComponent,
    ChartjsRadarComponent,
    ChartjsPieComponent,
    ChartjsMultipleXaxisComponent,
    ChartjsBarHorizontalComponent
  ],
  declarations: [...components]
})
export class ChartsModule { }
